import i18n from '../locales/i18n'
import { setPageSeo } from './seo'
import { ROUTE_LOCALE_KEY } from './geoRoutes'

export function applyRouteSeo(route) {
  const localeKey = ROUTE_LOCALE_KEY[route.name]
  if (!localeKey) return

  const locale = i18n.global.locale.value
  const messages = i18n.global.messages.value[locale] || i18n.global.messages.value.CN
  const page = messages[localeKey]
  if (!page?.seo) return

  document.documentElement.lang = locale === 'EN' ? 'en' : 'zh-CN'

  setPageSeo({
    title: page.seo.title,
    description: page.seo.description,
    keywords: page.seo.keywords,
    path: route.path,
    seo: page.seo,
    faqItems: page.geoFaq?.items || []
  })
}
